import { postEventService } from '@/services/PostEventService';
import { IonIcon, IonModal } from '@ionic/react';
import { createOutline, flagOutline, personAdd } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useState, useRef } from 'react';
import GolfIcon from './GolfIcon';
import GameSetup from './game-setup/GameSetup';
import { isDebugModeSync } from '@/utils/debugUtils';

interface AddActionSheetProps {
  className?: string;
  mode?: 'sidebar' | 'default';
}

const AddActionSheet: React.FC<AddActionSheetProps> = ({ className, mode = 'default' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showGameSetup, setShowGameSetup] = useState(false);
  const modal = useRef<HTMLIonModalElement>(null);
  const { t } = useTranslation();
  const history = useHistory();
  const isDebugMode = isDebugModeSync();

  const handleDismiss = () => {
    setIsOpen(false);
  };

  const handleCreatePost = () => {
    setIsOpen(false);
    // Trigger the global CreatePostModal using the postEventService
    postEventService.emit('openCreatePostModal', {});
  };

  const handleCreateGame = () => {
    setIsOpen(false);
    setShowGameSetup(true);
  };

  return (
    <>
      <button
        className={`${className} py-1 px-3 rounded-md`}
        onClick={() => setIsOpen(true)}
      >
        {mode === 'sidebar' ? (
          <div className="flex items-center gap-3 py-2">
            <GolfIcon name="add-square" className="size-6" />
            <span className="hidden xl:inline-block">{t('add')}</span>
          </div>
        ) : (
          <GolfIcon name="add-square" className="size-8" />
        )}
      </button>

      <IonModal
        ref={modal}
        isOpen={isOpen}
        onDidDismiss={handleDismiss}
        className='auto-height'
      >
        <div className="p-4 inner-content">
          <div className="flex flex-col gap-2 py-2">
            <button
              onClick={handleCreatePost}
              className="flex flex-row items-center p-3 rounded-lg bg-blue-50 dark:bg-blue-900/50 text-foreground hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors border border-blue-200 dark:border-blue-800"
            >
              <div className="p-2 rounded-full mr-3">
                <IonIcon icon={createOutline} className="text-blue-600 dark:text-blue-400 size-6" />
              </div>
              <span className="text-sm font-medium">{t('publish')}</span>
            </button>
            <button
              onClick={handleCreateGame}
              disabled={!isDebugMode}
              className="flex flex-row items-center p-3 rounded-lg bg-green-50 dark:bg-green-900/50 text-foreground hover:bg-green-100 dark:hover:bg-green-900/40 transition-colors border border-green-200 dark:border-green-800"
            >
              <div className="p-2 rounded-full mr-3">
                <IonIcon icon={flagOutline} className="text-green-600 dark:text-green-400 size-6" />
              </div>
              <span className="text-sm font-medium">{t('play_golf')} (Bientôt disponible)</span>
            </button>
            <button
              onClick={() => {
                setIsOpen(false);
                history.push('/friends');
              }}
              className="flex flex-row items-center p-3 rounded-lg bg-purple-50 dark:bg-purple-900/50 text-foreground hover:bg-purple-100 dark:hover:bg-purple-900/40 transition-colors border border-purple-200 dark:border-purple-800"
            >
              <div className="p-2 rounded-full mr-3">
                <IonIcon icon={personAdd} className="text-purple-600 dark:text-purple-400 size-6" />
              </div>
              <span className="text-sm font-medium">{t('add_friend')}</span>
            </button>
          </div>
        </div>
      </IonModal>

      {/* Game Setup Modal */}
      <GameSetup
        isOpen={showGameSetup}
        onClose={() => setShowGameSetup(false)}
      />
    </>
  );
};

export default AddActionSheet;
